<template>
	<div class="app-container">
		<div class="display-flex flex-column flex-1 content">
			<div class="app-content-container">
				<component v-if="pageHeaderComponent" :is="pageHeaderComponent" v-bind="pageHeaderComponentProps || {}" />
				<div class="app-content" :class="{ 'has-header': pageHeaderComponent, 'no-padding': noContentPadding }">
					<router-view />
				</div>
			</div>
		</div>
		<AppDialogManager />
	</div>
</template>

<script>
import 'vanilla-cookieconsent/src/cookieconsent.js';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import { mapActionsShorthand } from '@/store/utils/mappers';
import { ALL_PROJECTS_VIRTUAL_ID } from '@/utils/projects.const';
import { selectProjectId } from '@/store/modules/selectedProject/actions';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
import AppDialogManager from '@/components/dialogs/AppDialogManager/AppDialogManager';
import { SECONDARY_NAVIGATION_ITEMS, PRIMARY_NAVIGATION_ITEMS } from '@/views/AppLayout/AppNavigation/app-navigation.const.js';
export default {
	name: 'ExtensionAppLayout',
	components: {
		AppDialogManager,
	},
	computed: {
		routeName() {
			return this.$route.meta.title ?? this.$route.name;
		},
		allRoutes() {
			return [...this.primaryNavItems, ...this.secondaryNavItems];
		},
		currentRouteDetails() {
			return this.allRoutes.find((route) => route.routeName === this.$route.name) || {};
		},
		pageHeaderComponent() {
			return this.currentRouteDetails.headerComponent || this.$route.meta?.headerComponent;
		},
		pageHeaderComponentProps() {
			return this.currentRouteDetails.headerComponentProps?.(this.$route) || this.$route.meta?.headerComponentProps?.(this.$route);
		},
		noContentPadding() {
			return this.$route.meta?.noContentPadding || this.$route.matched.some((r) => r.meta.noContentPadding);
		},
		dontNotifyExtensionOnCreated() {
			return this.$route.meta?.dontNotifyExtensionOnCreated || this.$route.matched.some((r) => r.meta.dontNotifyExtensionOnCreated);
		},
	},
	methods: {
		...mapActionsShorthand({ selectProjectId }),
	},
	data: () => ({
		primaryNavItems: PRIMARY_NAVIGATION_ITEMS,
		secondaryNavItems: SECONDARY_NAVIGATION_ITEMS,
	}),
	created() {
		!this.dontNotifyExtensionOnCreated && ExtensionCommunicationService.notifyExtensionPageCreated();
		this.selectProjectId({ id: ALL_PROJECTS_VIRTUAL_ID });
	},
};
</script>

<style scoped lang="scss">
.app-container {
	$top-bar-height: 144px;

	display: flex;
	flex-direction: column;
	height: 100vh;
	width: 100vw;

	.app-content-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		max-width: 100%;
		overflow: hidden;
		z-index: 1;

		.app-content {
			flex: 1;
			display: flex;
			flex-direction: column;
			&:not(.no-padding) {
				padding: 0 3%;
			}
			&.has-header {
				max-height: calc(100% - #{$top-bar-height});
			}
		}
	}

	.app-content {
		position: relative; // so animation can work with position absolute on second'app-content'
	}

	.app-content-layout:nth-of-type(2) {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
	}
}
.content {
	max-height: 100%;
}
</style>
